import React, { Suspense } from "react";

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { ProtectedRoute } from "./helpers/authHelper";
import LoadingOverlay from "./components/common/Overlay";
import { getCurrentToken, getCurrentUser } from "./helpers/utility";
import { ROLE } from "./constant/constant";
import useNetwork from "./hook/Network";
import OfflinePage from "./components/common/Offline";

import "./styles/output.css";

// Router
const Auth = React.lazy(() => import("./pages/auth"));
const PagesApp = React.lazy(() => import("./pages"));
const NotFound = React.lazy(() => import("./pages/NotFound"));
const Unauthorize = React.lazy(() => import("./pages/Unauthorize"));

const App = () => {
  const user = getCurrentUser();
  const redirectDefault = ROLE[user?.role]?.defaultRedirect;
  const { online } = useNetwork();
  return (
    <>
      {online ? (
        <Suspense fallback={<LoadingOverlay isOpen={true} />}>
          <Router>
            <Switch>
              <Route
                exact
                path={process.env.REACT_APP_BASE_PATH || "/"}
                render={(props) =>
                  getCurrentToken() ? (
                    <Redirect to={`/${redirectDefault}`} />
                  ) : (
                    <Auth {...props} />
                  )
                }
              ></Route>
              <Route
                path="/unauthorize"
                exact
                render={(props) => <Unauthorize {...props} />}
              />
              <ProtectedRoute component={PagesApp} />
              <Route path="*" component={NotFound} />
            </Switch>
          </Router>
        </Suspense>
      ) : (
        <OfflinePage />
      )}
    </>
  );
};

export default App;
